import React, { useContext, useState } from "react";
import { Spinner } from "./Spinner";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { showConfirmationAlert, showDefaultAlert } from '../utils/Alerts';
import { UserContext } from "../contexts/UserContext";
import { addDealerImportedVehicle } from "../services/DealerImportedVehicleAPI";

const AddDealerImportedVehicleModel = ({ open, handleClose, addImportedVehicle }) => {
  const { user, token } = useContext(UserContext);
  const [importedVehicleChassisNo, setImportedVehicleChassisNo] = useState("");
  const [loaded, setLoaded] = useState(false);
  const inputSx = {
    '& .MuiInputLabel-root.Mui-focused': { color: '#4b5563' },
    '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#9ca3af' },
  };

  const handleAddImportedVehicle = () => {
    handleClose();
    const confirmationMessage = 'Are you sure you want to add new Dealer Imported Vehicle?';
    showConfirmationAlert({
      confirmationMessage,
      onConfirm: async () => {
        try {
          setLoaded(true);
          const response = await addDealerImportedVehicle(user.UserID, user.DealerID, importedVehicleChassisNo, token);
          setLoaded(false);
          if (response.status === 200) {
            addImportedVehicle(prevImportedVehicles => [...prevImportedVehicles, response.data]);
            showDefaultAlert('success', 'Success', 'Successfully Added Vehicle.');
            setImportedVehicleChassisNo('');
            handleClose(false);
          }
        } catch (error) {
          setLoaded(false);
          if (error.response.data.error === 'No Imported Vehicle Found') {
            showDefaultAlert('info', 'Info', 'No Imported Vehicle Found');
          } else {
            showDefaultAlert('error', 'Error', error.response?.data || error.message);
          }
          setImportedVehicleChassisNo('');
          handleClose(false);
        }
      },
      onCancel: async () => {
        handleClose(false);
        setImportedVehicleChassisNo('');
      },
    });
    handleClose();
  };

  const handleModalClose = () => {
    handleClose(false);
    setImportedVehicleChassisNo("");
  };

  return (
    <>
      {loaded ? (
        <div className="middle">
          {" "}
          <Spinner></Spinner>
        </div>
      ) : (
        <>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="add-del-serv-modal"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90vw", sm: 420 },
                maxWidth: 520,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: { xs: 3, sm: 4 },
                borderRadius: "10px",
                maxHeight: "90vh",
                overflowY: "auto",
              }}
            >
              <h2 id="modal-modal-title" style={{ color: "#c52b2b" }}>
                Add Imported Vehicle
              </h2>
              <TextField
                label="Imported Vehicles Chassis No"
                variant="outlined"
                fullWidth
                onChange={(e) => setImportedVehicleChassisNo(e.target.value)}
                margin="normal"
                helperText={!importedVehicleChassisNo ? "*Required" : ""}
                sx={inputSx}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  gap: 2,
                  marginTop: "16px",
                }}
              >
                <Button
                  onClick={handleModalClose}
                  variant="outlined"
                  color="primary"
                  sx={{ marginTop: '10px', width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 120 }, marginBottom: '5px' }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddImportedVehicle}
                  sx={{ marginTop: '10px', width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 120 }, marginBottom: '5px' }}
                  disabled={!importedVehicleChassisNo}
                >
                  Add
                </Button>
              </Box>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
};

export default AddDealerImportedVehicleModel;
